import { render } from "./JourneyView.vue?vue&type=template&id=5ec93bc7&scoped=true"
import script from "./JourneyView.vue?vue&type=script&lang=js"
export * from "./JourneyView.vue?vue&type=script&lang=js"

import "./JourneyView.vue?vue&type=style&index=0&id=5ec93bc7&lang=scss&scoped=true"

import exportComponent from "/home/duanpengyuan/Projects/freefi_meal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec93bc7"]])

export default __exports__